export default "__VITE_ASSET__CZegUg23__"